import drop from 'lodash/drop'
import dropRight from 'lodash/dropRight'
import forEach from 'lodash/forEach'
import head from 'lodash/head'
import join from 'lodash/join'
import includes from 'lodash/includes'
import last from 'lodash/last'
import size from 'lodash/size'
import split from 'lodash/split'
import toLower from 'lodash/toLower'

const lowerWords = ['to', 'in', 'from', 'and', 'a', 'an', 'at', 'or']

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const formatItineraryTitle = (title) => {
  const splitTitle = split(title, ' ')

  const firstWord = capitalizeFirstLetter(head(splitTitle))
  const middleWords = dropRight(drop(splitTitle))
  const lastWord = capitalizeFirstLetter(last(splitTitle))

  const formattedTitle = []
  formattedTitle.push(firstWord)
  forEach(middleWords, word => {
    const lower = toLower(word)
    if (includes(lowerWords, lower)) {
      formattedTitle.push(lower)
    } else {
      formattedTitle.push(capitalizeFirstLetter(word))
    }
  })
  if (size(splitTitle) > 1) {
    formattedTitle.push(lastWord)
  }

  return join(formattedTitle, ' ')
}